import React from 'react';
import DashboardComponent from '../../components/DashboardComponent';

export default function AdminDashboard(props) {
  props.toast.dismiss();

  const buttons = [
    {
      onClick: () => {
        props.history.push('/Dashboard');
      },
      title: 'Dashboard',
      visible: true,
    },
  ];

  return <DashboardComponent title='Admin Dashboard' buttons={buttons} toast={props.toast} />;
}
